"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const DialogWrapperRenderer_1 = __importDefault(require("../DialogWrapperRenderer"));
const style_1 = __importDefault(require("./style"));
const inputValueApplyTextMask_1 = __importDefault(require("../../../shared/inputValueApplyTextMask"));
const InputDialogRenderer = ({ inputDialogContext }) => {
    const [value, setValue] = (0, react_1.useState)('');
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const platform = processor.root.platformOS;
    const onSubmit = (0, react_1.useCallback)(() => {
        if (value.length && (inputDialogContext === null || inputDialogContext === void 0 ? void 0 : inputDialogContext.onSubmit)) {
            inputDialogContext.onSubmit(value);
            setValue('');
        }
        else if (inputDialogContext === null || inputDialogContext === void 0 ? void 0 : inputDialogContext.onEmpty) {
            inputDialogContext.onEmpty();
        }
    }, [inputDialogContext, value]);
    const onClose = (0, react_1.useCallback)(() => {
        if (inputDialogContext === null || inputDialogContext === void 0 ? void 0 : inputDialogContext.onClose) {
            inputDialogContext.onClose();
        }
        setValue('');
    }, [inputDialogContext]);
    return (react_1.default.createElement(DialogWrapperRenderer_1.default, { title: inputDialogContext === null || inputDialogContext === void 0 ? void 0 : inputDialogContext.title, description: inputDialogContext === null || inputDialogContext === void 0 ? void 0 : inputDialogContext.description, onOk: onSubmit, onCancel: onClose },
        react_1.default.createElement(Render.TextInput, { isFocused: false, value: value, multiline: false, maxLength: 255, placeholder: "Write a value", placeholderTextColor: "#bdbdbd", secureTextEntry: false, returnKeyType: "done", style: platform === 'android' ? style_1.default.inputAndroid : style_1.default.inputIos, blurOnSubmit: false, onChangeText: (newValue) => {
                var _a;
                return setValue((0, inputValueApplyTextMask_1.default)({
                    inputValue: newValue,
                    mask: (_a = inputDialogContext === null || inputDialogContext === void 0 ? void 0 : inputDialogContext.mask) !== null && _a !== void 0 ? _a : undefined,
                }));
            } })));
};
exports.default = InputDialogRenderer;
